import { render, staticRenderFns } from "./tranSaleReturns.vue?vue&type=template&id=fb591db8&scoped=true&"
import script from "./tranSaleReturns.vue?vue&type=script&lang=js&"
export * from "./tranSaleReturns.vue?vue&type=script&lang=js&"
import style0 from "./tranSaleReturns.vue?vue&type=style&index=0&id=fb591db8&lang=less&scoped=true&"
import style1 from "./tranSaleReturns.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb591db8",
  null
  
)

component.options.__file = "tranSaleReturns.vue"
export default component.exports